import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { BookingDurationTypeModel } from "@/model/enum/BookingDurationType.model";
import { createProduct, initProduct } from "@/model/Product";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { DateUtil } from "@/util/DateUtil";
export default /*@__PURE__*/ _defineComponent({
    __name: 'KrumosCalendar',
    props: {
        product: { type: Object, required: false },
        initDateFrom: { type: Date, required: true },
        initDateTo: { type: Date, required: true }
    },
    emits: ["dateSelected"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        let rangeSelected = true;
        let dateFrom = ref(new Date(props.initDateFrom));
        let dateTo = ref(new Date(props.initDateTo));
        let localProduct = reactive(createProduct());
        const emit = __emit;
        onMounted(() => {
            if (props.product) {
                initProduct(localProduct, props.product);
            }
            else {
                localProduct.bookingDurationType = BookingDurationTypeModel.VARIABLE;
            }
            // Validate and adjust dates on initial mount
            validateAndAdjustDates();
        });
        watch(() => props.product, (newValue) => {
            if (newValue) {
                initProduct(localProduct, newValue);
                validateAndAdjustDates();
            }
            else {
                // If product is cleared, reset to variable booking type
                localProduct.bookingDurationType = BookingDurationTypeModel.VARIABLE;
            }
        });
        function validateAndAdjustDates() {
            // For FIXED duration bookings, adjust the dateTo based on bookingIntervalLength
            if (localProduct.bookingDurationType === BookingDurationTypeModel.FIXED && localProduct.bookingIntervalLength) {
                const tempDate = new Date(dateFrom.value);
                tempDate.setDate(dateFrom.value.getDate() + localProduct.bookingIntervalLength - 1);
                dateTo.value = tempDate;
                emit("dateSelected", dateFrom.value, dateTo.value);
            }
            // For VARIABLE duration with pricedPerNight, ensure dateTo is at least one day after dateFrom
            else if (localProduct.bookingDurationType === BookingDurationTypeModel.VARIABLE &&
                localProduct.priceStructure.pricedPerNight &&
                DateUtil.isSameDay(dateFrom.value, dateTo.value)) {
                let tempDate = new Date(dateFrom.value);
                tempDate.setDate(dateFrom.value.getDate() + 1);
                dateTo.value = tempDate;
                emit("dateSelected", dateFrom.value, dateTo.value);
            }
        }
        const calendarAttributes = computed(() => {
            return [
                {
                    highlight: {
                        start: { fillMode: 'outline' },
                        base: { fillMode: 'light' },
                        end: { fillMode: 'outline' },
                    },
                    dates: { start: dateFrom.value, end: dateTo.value }
                }
            ];
        });
        const initialPage = computed(() => {
            return {
                year: dateFrom.value.getFullYear(),
                month: dateFrom.value.getMonth() + 1 // JavaScript months are 0-indexed
            };
        });
        function onDateClicked($event) {
            switch (localProduct.bookingDurationType) {
                case BookingDurationTypeModel.FIXED: {
                    dateFrom.value = new Date($event.id);
                    const tempDate = new Date(dateFrom.value);
                    tempDate.setDate(dateFrom.value.getDate() + localProduct.bookingIntervalLength - 1);
                    dateTo.value = tempDate;
                    emit("dateSelected", dateFrom.value, dateTo.value);
                    break;
                }
                case BookingDurationTypeModel.VARIABLE: {
                    if (rangeSelected) {
                        dateFrom.value = new Date($event.id);
                        dateTo.value = new Date($event.id);
                        if (localProduct.priceStructure.pricedPerNight) {
                            let tempDate = new Date(dateTo.value);
                            tempDate.setDate(dateTo.value.getDate() + 1);
                            dateTo.value = tempDate;
                        }
                        rangeSelected = false;
                    }
                    else {
                        rangeSelected = true;
                        // Switch dates if they are reversed
                        if (dateFrom.value > dateTo.value) {
                            let temp = dateFrom.value;
                            dateFrom.value = dateTo.value;
                            dateTo.value = temp;
                        }
                        emit("dateSelected", dateFrom.value, dateTo.value);
                    }
                    break;
                }
                default:
                    throw new Error(`Unexpected BookingDurationType: ${localProduct.bookingDurationType}`);
            }
        }
        function onHoverDate($event) {
            switch (localProduct.bookingDurationType) {
                case BookingDurationTypeModel.FIXED:
                    break;
                case "VARIABLE":
                    if (dateTo.value && !rangeSelected) {
                        dateTo.value = new Date($event.id);
                    }
                    break;
                default:
                    throw new Error(`Unexpected BookingDurationType: ${localProduct.bookingDurationType}`);
            }
        }
        return (_ctx, _cache) => {
            const _component_vc_calendar = _resolveComponent("vc-calendar");
            return (_openBlock(), _createBlock(_component_vc_calendar, {
                "is-dark": true,
                onDayclick: _cache[0] || (_cache[0] = ($event) => (onDateClicked($event))),
                onDaymouseenter: _cache[1] || (_cache[1] = ($event) => (onHoverDate($event))),
                attributes: calendarAttributes.value,
                "initial-page": initialPage.value
            }, null, 8, ["attributes", "initial-page"]));
        };
    }
});
